import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkAuthenticatedUser } from '../../utils/client-functions';
// import { useSelector } from 'react-redux';
import AuthHeader from "../UI/AuthHeader/AuthHeader";
import AuthSideMenu from "../UI/AuthSideMenu/AuthSideMenu";
import { StepsContainerStyled, CourseVideoRow } from "../../styled/Resume";
// import Button from "../UI/Buttons/Button";
import { ButtonThin } from "../UI/Buttons/Buttons";
import Alert from "@mui/material/Alert";
import { Rating } from "@mui/material";
import MainModal from "../UI/Modal/MainModal";
import axios from 'axios';
import OvalSpinner from "../UI/Spinners/OvalSpinner";
import chipCss from "../Resume/Chips.module.css";
import { FaPlay } from "react-icons/fa";
import { useTheme } from "../UI/Theme/ThemeContext";

const Courses = () => {
  const { themeName } = useTheme();
  // const { stateData } = useSelector(state => state);
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

  const navigate = useNavigate();

  const [items, setItems] = useState([]); // saved courses
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState('');

  const [playItem, setPlayItem] = useState(null); // item to play in modal
  const [savingProgress, setSavingProgress] = useState(false);

  const [remindersOpen, setRemindersOpen] = useState(false);
  const [remItem, setRemItem] = useState(null);
  const [remindersDraft, setRemindersDraft] = useState([]);
  const [savingReminders, setSavingReminders] = useState(false);
  // side menu toggle (hamburger)
  const [authMenuOpen, setAuthMenuOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        try {
          await checkAuthenticatedUser();
        } catch (error) {
          setLoading(false);
          return navigate('/popin?courses');
        }

        const resp = await axios.get('/user/courses', { headers: { 'x-access-token': token } });
        if (!cancelled) setItems(Array.isArray(resp?.data?.items) ? resp.data.items : []);
      } catch (e) {
        // ignore for now
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [token, navigate]);

  const percentWatched = (it) => {
    const cur = it?.progress?.currentTimeSecs || 0;
    const tot = it?.progress?.totalSeconds || 0;
    if (!tot) return 0;
    return Math.min(100, Math.round((cur / tot) * 100));
  };

  const startUrl = (it) => {
    const vid = it?.videoId;
    const s = it?.progress?.currentTimeSecs || 0;
    if (!vid) return null;
    return `https://www.youtube.com/embed/${vid}?start=${Math.max(0, Math.floor(s))}&autoplay=1`;
  };

  const markCompleted = async (it) => {
    if (!it?._id) return;
    try {
      setSavingProgress(true);
      const body = { completed: true };
      const resp = await axios.patch(`/user/courses/${it._id}/progress`, body, { headers: { 'x-access-token': token } });
      if (resp?.data?.ok) {
        setItems(prev => prev.map(x => x._id === it._id ? resp.data.course : x));
      }
    } catch (_) {}
    finally { setSavingProgress(false); }
  };

  const saveRating = async (it, rating) => {
    if (!it?._id) return;
    try {
      const resp = await axios.patch(`/user/courses/${it._id}/progress`, { rating }, { headers: { 'x-access-token': token } });
      if (resp?.data?.ok) {
        setItems(prev => prev.map(x => x._id === it._id ? resp.data.course : x));
      }
    } catch (_) {}
  };

  const openReminders = (it) => {
    setRemItem(it);
    // Seed with existing reminders; if no one-time reminder, default to next day's 09:00 local time
    const pad2 = (n) => String(n).padStart(2, '0');
    const nextDayISO = () => {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      d.setHours(9, 0, 0, 0);
      return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
    };
    const base = Array.isArray(it?.reminders) ? it.reminders.slice() : [];
    const hasOnce = base.some(r => r && r.type === 'once' && r.timeISO);
    if (!hasOnce) base.push({ type: 'once', timeISO: nextDayISO(), active: true });
    setRemindersDraft(base);
    setRemindersOpen(true);
  };

  const toggleWeeklyDay = (day) => {
    setRemindersDraft(prev => {
      const copy = prev.slice();
      const idx = copy.findIndex(r => r.type === 'weekly');
      if (idx === -1) {
        copy.push({ type: 'weekly', daysOfWeek: [day], active: true });
      } else {
        const arr = new Set(copy[idx].daysOfWeek || []);
        arr.has(day) ? arr.delete(day) : arr.add(day);
        copy[idx] = { ...copy[idx], daysOfWeek: Array.from(arr) };
      }
      return copy;
    });
  };

  const saveReminders = async () => {
    if (!remItem?._id) return;
    try {
      setSavingReminders(true);
      const resp = await axios.put(`/user/courses/${remItem._id}/reminders`, { reminders: remindersDraft }, { headers: { 'x-access-token': token } });
      if (resp?.data?.ok) {
        setItems(prev => prev.map(x => x._id === remItem._id ? resp.data.course : x));
        setRemindersOpen(false);
      }
    } catch (_) {}
    finally { setSavingReminders(false); }
  };

  return (
    <div style={{ display: 'grid', minHeight: '100vh', width: '100%'}}>
      <AuthSideMenu opened={authMenuOpen}/>
        <AuthHeader authMenuOpen={authMenuOpen} onClick={() => setAuthMenuOpen(v => !v)} />
      <div style={{ width: '100%', margin: '3.5rem 0' }}>

        <div style={{ width: '100%', padding: '2.5% 2.5% 0', margin: '20px 0' }}>
          <h2>Saved Courses</h2>
          <Alert severity="info" sx={{ mb: 1 }}>You can set reminders to keep learning.</Alert>
        </div>

        <StepsContainerStyled>
          {loading ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 200 }}>
              <OvalSpinner size={36} color="#5fbec5" />
            </div>
          ) : items.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem 0' }}>
              No saved courses yet. 
              <a href="/user/dashboard/resume" style={{ color: '#009990', textDecoration: 'underline', marginLeft: 6, fontWeight: 600 }}>
                Create Resume
              </a>
              &nbsp;to Get Courses
            </div>
          ) : (
            <>
              <style>{`
                .coursesGrid { box-sizing: border-box; display:grid; gap:12px; width:100%; padding: 0 2.5%; margin:0; grid-template-columns: repeat(1, minmax(0, 1fr)); }
                @media (min-width: 700px){ .coursesGrid { grid-template-columns: repeat(2, 1fr); } }
                @media (min-width: 1024px){ .coursesGrid { grid-template-columns: repeat(3, 1fr); } }
              `}</style>
              <div className="coursesGrid">
              {items.map(it => (
                <div
                  key={it._id}
                  style={{
                    border: themeName === 'dark' ? '1px solid rgba(255,255,255,0.06)' : '1px solid rgba(0,0,0,0.08)',
                    borderRadius: 12,
                    overflow: 'hidden',
                    background: themeName === 'dark' ? 'rgba(255,255,255,0.03)' : '#fff',
                    color: themeName === 'dark' ? '#fff' : '#000',
                    minWidth: 0
                  }}
                >
                  <div style={{ position: 'relative', paddingTop: '56.25%', background: '#f6f6f6' }}>
                    {it.thumbnail && (
                      <img src={it.thumbnail} alt={it.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                    )}
                  </div>
                  <div style={{ padding: 10 }}>
                    <div style={{ fontWeight: 600, marginBottom: 6 }}>{it.title}</div>
                    <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 8 }}>
                      Watched: {percentWatched(it)}% {it?.progress?.completed ? '• Completed' : ''}
                    </div>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                      <ButtonThin height="28px" onClick={() => setPlayItem(it)} color={themeName === 'dark' ? '#0C1E28' : '#000'}>
                        <FaPlay style={{ color: 'crimson', marginRight: 6 }} /> Resume
                      </ButtonThin>
                      <ButtonThin height="28px" onClick={() => markCompleted(it)} disabled={savingProgress} color={themeName === 'dark' ? '#0C1E28' : '#000'}>Done</ButtonThin>
                      <ButtonThin height="28px" onClick={() => openReminders(it)} color={themeName === 'dark' ? '#0C1E28' : '#000'}>Reminders</ButtonThin>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8 }}>
                      <span style={{ fontSize: 12 }}>Rating:</span>
                      <Rating size="small" value={Number(it?.progress?.rating || 0)} onChange={(_, v) => saveRating(it, v || 0)} />
                    </div>
                  </div>
                </div>
              ))}
              </div>
            </>
          )}
        </StepsContainerStyled>
      </div>

      {/* Player modal */}
      <MainModal isOpen={!!playItem} onClose={() => setPlayItem(null)} width={'70%'} height={520}>
        {playItem && (
          <div style={{ marginTop: 50, width: '100%', alignSelf: 'stretch' }}>
            <CourseVideoRow style={{ width: '100%', alignSelf: 'stretch' }}>
              <div className="videoWrapper">
                <iframe
                  src={startUrl(playItem)}
                  title={playItem.title}
                  style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </CourseVideoRow>
            <div style={{ marginTop: 10, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <ButtonThin height="28px" onClick={() => markCompleted(playItem)} disabled={savingProgress} color={themeName === 'dark' ? '#0C1E28' : '#000'}>Mark Done</ButtonThin>
            </div>
          </div>
        )}
      </MainModal>

      {/* Reminders modal */}
      <MainModal isOpen={remindersOpen} onClose={() => setRemindersOpen(false)} width={'520px'} height={420}>
        <div style={{ marginTop: 50, padding: 10, color: '#000', width: '100%' }}>
          <h3 style={{ margin: '8px 0' }}>Scheduling reminders</h3>
          <Alert
            severity="info"
            sx={{
              mb: 1,
              fontSize: '.85rem',
              bgcolor: themeName === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,153,144,0.08)',
              color: themeName === 'dark' ? '#fff' : '#003d40',
              '& .MuiAlert-icon': { color: themeName === 'dark' ? '#5fbec5' : '#009990' }
            }}
          >
            Choose daily, weekly, or a one-time reminder. Weekly: select days below.
          </Alert>
          {/* One-time schedule */}
          <div style={{ marginBottom: 10 }}>
            <div style={{ fontSize: 12, marginBottom: 4 }}>Once at</div>
            <input type="datetime-local" value={remindersDraft.find(r=>r.type==='once')?.timeISO || ''}
                   onChange={(e) => {
                     const v = e.target.value;
                     setRemindersDraft(prev => {
                       const copy = prev.filter(r => r.type !== 'once');
                       copy.push({ type: 'once', timeISO: v, active: true });
                       return copy;
                     });
                   }}
                   style={{
                     height: 34,
                     borderRadius: 8,
                     border: themeName === 'dark' ? '1px solid rgba(255,255,255,0.2)' : '1px solid rgba(0,0,0,0.15)',
                     padding: '4px 8px',
                     width: '100%',
                     maxWidth: 280,
                     background: themeName === 'dark' ? '#0C1E28' : '#fff',
                     color: themeName === 'dark' ? '#fff' : '#000'
                   }} />
          </div>

          {/* Daily toggle */}
          <div style={{ marginBottom: 10 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
              <input type="checkbox" checked={!!remindersDraft.find(r => r.type==='daily')}
                     onChange={() => {
                       setRemindersDraft(prev => {
                         const has = !!prev.find(r=>r.type==='daily');
                         if (has) return prev.filter(r=>r.type!=='daily');
                         return prev.concat([{ type: 'daily', active: true }]);
                       });
                     }} />
              Daily reminder
            </label>
          </div>

          {/* Weekly days */}
          <div style={{ marginBottom: 10 }}>
            <div style={{ fontSize: 12, marginBottom: 4 }}>Weekly on</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {[0,1,2,3,4,5,6].map(d => (
                <span
                  key={d}
                  className={`${chipCss.chip} array-item`}
                  style={{ cursor: 'pointer', color: '#000' }}
                  onClick={() => toggleWeeklyDay(d)}
                >
                  {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d]}
                </span>
              ))}
            </div>
          </div>

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <ButtonThin onClick={() => setRemindersOpen(false)} height="32px" color={'#000'}>Close</ButtonThin>
            <ButtonThin onClick={saveReminders} height="32px" disabled={savingReminders} color={'#000'}>
              {savingReminders ? 'Saving…' : 'Save'}
            </ButtonThin>
          </div>
        </div>
      </MainModal>
    </div>
  );
};

export default Courses;
